import * as actionTypes from './actionTypes';
import axios from '../../axios/Backend';
import * as settingsReq from '../../axios/requests/settingsReq'

export const fetchSettingsSuccess = (companySettings) => {
    return {
        type: actionTypes.FETCH_SETTINGS_SUCCESS,
        companySettings: companySettings
    };
};

export const fetchSettings = () => {

    return async dispatch => {
        try {
            // dispatch(loginStart())
            const resData = await axios.get('/companySettings/GetAllSettings');
            const companySettings = resData.data;
            dispatch(fetchSettingsSuccess(companySettings));
        }
        catch (e) {
            // dispatch(loginFail(e));
            console.log(e);
        }
    }
}
const changePermissionType = (value) => {
    return async dispatch => {
        try {
            console.log('new user permission=' + JSON.stringify(value))
            axios.post('/users/update/' + value.agent, { permissionType: value.permissionType });
        } catch (e) {
            console.log('changePermissionType :: Error=' + JSON.stringify(e))
        }
    }
}
export const setSettings = (settingType, settingName, value) => {
    return async dispatch => {
        if (settingType === 'onUserTabel') {
            switch (settingName) {
                case 'userPermission': 
                    return changePermissionType(value);
                default: 
                    return console.log('Wrong Setting name');
            }
        } else {
            try {
                if (settingName === 'onSetBotActivity') {
                    await settingsReq.updateSpecificSetting({
                        bot: {
                            activeBot: value
                        }
                    });
                } else if (['activeStartDay', 'activeEndDay', 'activeStartTime', 'activeEndTime'].includes(settingName)) {
                    await settingsReq.updateSpecificSetting({
                        bot: {
                            [settingName]: value
                        }
                    });
                }
                dispatch({
                    type: actionTypes.SET_SETTING,
                    settingType: settingType,
                    settingName: settingName,
                    value: value
                });
            } catch (e) {
                console.log('setSettings :: Error=' + JSON.stringify(e));
            }
        }
    };
};

export const clearSettingsState = ()=>{
    return {
        type: actionTypes.CLEAR_SETTINGS_STATE
    }
}



